/*
* Auto Build of UAT Client Extension Includes
*/

module.exports = [
  require("../dashboard/client.js"),
];
